import React from 'react';
import { useEffect, useState } from 'react';
import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from '../../../../../sessionStorage';
import AboutMeForm from '../../../../Quoters/MCT/steps/AboutMeForm';
import AboutData from './AboutData';

export default function EtradeTermData(props) {
    const [quickQuoteDisclaimer, setQuickQuoteDisclaimer] = useState(null);
    const [primaryBrandColor, setPrimaryBrandColor] = useState(null)

    useEffect(() => {
        var accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
        setQuickQuoteDisclaimer(accountObj.account.quickQuoteDisclaimerHtml);
        setPrimaryBrandColor(accountObj.account.primaryColor);
    }, []);

    return {
        name: "Term Life Insurance",
        subtitle: "",
        subtitleExtended: "",
        heroText: [
            {
                title: "Term Life Insurance",
                subtitle: "Easy online experience",
                subtitleExtended: "See your coverage options in minutes without the wait*"
            },
            {
                title: "Term Life Insurance",
                subtitle: "Extensive choice and convenience",
                subtitleExtended: "Instantly get and compare quotes from top-rated carriers"
            },
            {
                title: "Term Life Insurance",
                subtitle: "Life insurance that's right for you",
                subtitleExtended: "Easily assess your needs to determine the right term and amount of coverage"
            },
            {
                title: "Term Life Insurance",
                subtitle: "In-person help is always available",
                subtitleExtended: "Get assistance via phone from Covr's licensed specialists in all 50 states"
            }
        ],
        basicInfoForm: (history) => {
            return <AboutMeForm
                ageSpecs={{ min: 18, max: 70 }}
                onNext={() => {
                    props.history.push('/quote/term-life-insurance/multi-carrier-term/pre-quote');
                }}
                quickQuoteDisclaimer={quickQuoteDisclaimer}
                brandTheme={primaryBrandColor}
                showHeader={false}
                submitButtonVariant={'landing'}
            />;
        },
        about: AboutData(),
        hasQuickQuoteDisclaimer: quickQuoteDisclaimer !== null,
    };
};



// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/EtradeTerm/EtradeTermData.js